var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "1对多类型选择题编辑",
        visible: _vm.dialogVisible,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.dialogOpen,
        close: _vm.close
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            size: "small",
            rules: _vm.rules,
            disabled: !_vm.isEdit
          }
        },
        [
          _c("el-form-item", { attrs: { label: "题目类型" } }, [
            _vm._v(" 1对多选择题 ")
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "标题", prop: "title" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入内容",
                  autosize: { minRows: 2 }
                },
                model: {
                  value: _vm.form.title,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "正文", prop: "content" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入内容",
                  autosize: { minRows: 3 }
                },
                model: {
                  value: _vm.form.content,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "content", $$v)
                  },
                  expression: "form.content"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "图片", prop: "pic" } },
            [
              _c("uploadpic", {
                ref: "picUpload",
                attrs: { "file-list": _vm.picFileList }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "音频文件" } },
            [
              _c("uploadfile", {
                ref: "audioUpload",
                attrs: { "file-list": _vm.audioFileList }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "题目", prop: "question" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入内容",
                  autosize: { minRows: 2 }
                },
                model: {
                  value: _vm.form.question,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "question", $$v)
                  },
                  expression: "form.question"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "正确答案", prop: "correctAnswer" } },
            [
              _vm._l(_vm.form.correctAnswer, function(item1, index) {
                return _c(
                  "el-row",
                  {
                    key: index,
                    staticStyle: { "padding-bottom": "3px" },
                    attrs: { gutter: "3", span: 15 }
                  },
                  [
                    _c("el-col", { attrs: { span: 1 } }, [
                      _vm._v(_vm._s(index + 1) + ".")
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "number",
                            placeholder: "选项个数",
                            min: "1"
                          },
                          model: {
                            value: _vm.form.choiceItem[index],
                            callback: function($$v) {
                              _vm.$set(_vm.form.choiceItem, index, $$v)
                            },
                            expression: "form.choiceItem[index]"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "90px" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.form.correctAnswer[index],
                              callback: function($$v) {
                                _vm.$set(_vm.form.correctAnswer, index, $$v)
                              },
                              expression: "form.correctAnswer[index]"
                            }
                          },
                          _vm._l(_vm.form.choiceItemIndex, function(item) {
                            return _c("el-option", {
                              key: item,
                              attrs: { label: item, value: item }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 3 } },
                      [
                        _c("el-button", {
                          staticClass: "el-icon-minus",
                          staticStyle: {
                            border: "1px solid #a9aaad",
                            padding: "2px"
                          },
                          on: { click: _vm.removeCorrectAnswerItem }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c("el-button", {
                staticClass: "el-icon-plus",
                staticStyle: { border: "1px solid #a9aaad", padding: "2px" },
                on: { click: _vm.newCorrectAnswerItem }
              })
            ],
            2
          ),
          _c(
            "el-form-item",
            { attrs: { label: "分值", prop: "score" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  autosize: "",
                  placeholder: "请输入内容",
                  min: "0",
                  max: "100"
                },
                model: {
                  value: _vm.form.score,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "score", $$v)
                  },
                  expression: "form.score"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序", prop: "orderIndex" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  autosize: "",
                  placeholder: "请输入内容",
                  min: "1",
                  max: "100"
                },
                model: {
                  value: _vm.form.orderIndex,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "orderIndex", $$v)
                  },
                  expression: "form.orderIndex"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticStyle: { "text-align": "center" } },
            [
              _vm.isEdit
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.save }
                    },
                    [_vm._v("保存")]
                  )
                : _vm._e(),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }